import { TFunction } from 'react-i18next';

export const replaceSummary = (value: string, t: TFunction<'translation'>) =>
  value
    .replaceAll('x)', ` x) ${t('room.rooms')} `)
    .replaceAll('(', ``)
    .replaceAll(')', ``)
    .replaceAll(':childCount', ` ${t('room.child')}(s)`)
    .replaceAll(':adultCount', ` ${t('room.Adult')}(s)`);
